module.exports = __webpack_public_path__ + "static/media/audio.4ca6edfe.svg";